/**
* @typedef AmpersendParams
* @type {Object}
* @property {String} audienceIds
* @property {String} experienceIds
* @property {String} agentId
*/

/**
 * Check window variable for destinationURL
 * @return {String}
 */
export const getDestinationURLParam = () => {
  let destinationUrl = window?.ampExperienceData?.destinationUrl ?? '';
  if (process.env.NODE_ENV !== 'production') {
    destinationUrl = destinationUrl.replace('//app.mymove.com', '//staging-app.mymove.com');
  }
  return destinationUrl;
};

/**
 * Generate the Ampersend payload for Access handoff request
 * @return {AmpersendParams}
 */
export const getAmpersendParams = () => {
  const {
    audienceIds = '',
    experienceIds = '',
    agentId = '',
  } = JSON.parse(localStorage.getItem('ampersend_data') || '{}');

  return {
    audienceIds,
    experienceIds,
    agentId,
  };
};

export const getAllAmpersendParams = () => {
  const params = {};
  const ampData = JSON.parse(sessionStorage.getItem('amp_data'));
  if (ampData) {
    const data = ampData.reduce((accum, curr) => {
      accum.experienceIds.add(curr.experienceGroupId);
      accum.audienceIds.add(curr.id);
      accum.agentId.add(curr.accountId);
      return accum;
    }, { experienceIds: new Set(), audienceIds: new Set(), agentId: new Set() });

    data.experienceIds = [...data.experienceIds];
    data.agentId = [...data.agentId];
    data.audienceIds = [...data.audienceIds];
    Object.assign(params, data);
  }
  return params;
};
